<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ia7RF1/tc-custom/9781555848910.jpg?1705766093057" alt="This image is the cover for the book Importance of a Piece of Paper"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Importance of a Piece of Paper
      </h1>
      <p class="bookDescription body article font2">
        <b>“In Jimmy Santiago Baca’s haunting story collection, intricate family dramas . . . play out against the luminous, wide-open backdrop of New Mexico.” —<i>Los Angeles Times</i></b><br/>  <br/> In his first foray into short fiction, award-winning poet and memoirist Jimmy Santiago Baca explores the territory where old-world traditions meet new-world ambitions, and characters try to make something of themselves, while keeping their souls intact. In “Matilda’s Garden,” an old farmer pines for his wife of fifty years who died in her sleep one-night months before. He is lured to the garden in the middle of the night by what he thinks is her presence, only to meet a gruesome fate. In “The Importance of a Piece of Paper,” two siblings must face the brother who has betrayed them by selling his share of the family land, leaving an entire community vulnerable. In “The Three Sons of Julia,” a long-suffering mother whose one request is that all her sons come home for the Fourth of July, watches her dream burst as two of her sons—one a successful businessman and the other a hard-drinking ex-con—nearly destroy her house, and each other. Merging a refreshing innocence with a profound understanding of the world’s brutality, <i>The Importance of a Piece of Paper</i> is a daring and arresting work that is at once fearless, tender, and inspiring.<br/>  <br/> “[Baca] continues to mine his experience, exploring conflicts between the rich traditions of Chicano culture and a modern world impatient with them.” —<i>Entertainment Weekly</i><br/>  <br/> “Inspirational, tragic, and redeeming . . . Baca provides moving poetic imagery and unleashes his gift for finely crafted sensory detail.” —<i>Rocky Mountain News</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jimmy Santiago Baca
      </h2>
      
      <p class="authorDescription body article">Jimmy Santiago Baca was born in Santa Fe, New Mexico. His awards and honors include the Wallace Stevens Chair at Yale, the National Endowment of Poetry Award, Vogelstein Foundation Award, National Hispanic Heritage Award, Berkeley Regents Award, Pushcart Prize, Southwest Book Award, the American Book Award, and the International Prize.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grove Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?60535c8d